









































import { Component, Vue, Prop } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card.vue';
import MasterStore from '@/store/MasterStore';
import AppStore from '@/store/App';

@Component({
  components: {
    MaterialCard,
  },
})
export default class Login extends Vue {
  mail: string = "";
  pass: string = "";

  mounted() {
    let login: any = this.$refs.login;
    login.addEventListener('submit', async (event: any) => {
      event.preventDefault();
      const result = await MasterStore.execAuthentication({ user: this.mail, password: this.pass });
      // ログイン成功ならリダイレクト
      if(result) {
        if(typeof(this.$route.query.redirect) === "string")
          this.$router.push(this.$route.query.redirect);
        else
          this.$router.push('/company');
      }
      else {
        AppStore.showError("認証に失敗しました。ユーザー名とパスワードを確認してください。");
      }
    }, false);
  }
}
